import styles from './index.module.scss'

export function GradientText({ text }: { text: string }) {
  return <div className={styles.gradient}>{text}</div>
}
